class TrRunningLine extends HTMLElement {
	selectors = {
		list: '[data-js-list]',
		item: '[data-js-item]',
	};

	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.itemElements = this.querySelectorAll(this.selectors.item);

		if (!this.itemElements.length) return;

		this.cloning();
	}

	cloning() {
		let scrollWidth = this.scrollWidth;
		const offsetWidth = this.offsetWidth;

		do {
			this.innerHTML += this.innerHTML;
			scrollWidth = this.scrollWidth;
		} while (scrollWidth < offsetWidth * 2);

		this.querySelectorAll(this.selectors.list).forEach((listElement, index) => {
			if (index < 1) return;

			listElement.setAttribute('aria-hidden', 'true');
		});
	}
}

customElements.define('tr-running-line', TrRunningLine);
